/**
 * Knob Component
 * 
 * Displays a labeled progress bar representing a performance parameter value.
 * Used for Dynamics, Complexity, and Fills indicators.
 */

import React from 'react';
import './Knob.css';

/**
 * Progress bar visualization for knob values
 * 
 * @param {object} props - Component props
 * @param {[number, number]} props.range - Value range [start, end] from 0-1
 */
function ProgressBar({ range }) {
  const [start, end] = range;
  const leftPercent = start * 100;
  const widthPercent = (end - start) * 100;
  
  return (
    <div className="progress-bar-track">
      <div
        className="progress-bar-fill"
        style={{
          width: `${widthPercent}%`,
          marginLeft: `${leftPercent}%`,
        }}
      />
    </div>
  );
}

/**
 * Knob component with label and progress bar
 * 
 * @param {object} props - Component props
 * @param {string} props.label - Knob label (e.g., 'D', 'C', 'F')
 * @param {[number, number]} props.range - Value range [start, end] from 0-1
 */
export function Knob({ label, range }) {
  return (
    <div className="knob">
      <span className="knob-label">{label}:</span>
      <ProgressBar range={range} />
    </div>
  );
}


